import { toast } from 'react-toastify';
import appApi from '../../../../../api/app-api';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';
import { StandingOrderBankTransferCancelReasonDetailsEntity } from '../../../../../api/types/settings/standing-order-bank-transfer/standing-order-bank-transfer.type';

export const getStandingOrderBankTransferCancelReasonsListOperation = async (
  offset: number,
  limit: number,
  setData: (data: StandingOrderBankTransferCancelReasonDetailsEntity[]) => void,
  setTotal: (total: number) => void,
  setLoading: (loading: boolean) => void,
) => {
  try {
    setLoading(true);

    const res = await appApi.getStandingOrderBankTransferCancelReasonsList({
      offset,
      limit,
    });

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }

    setData(res.data.body?.data ?? []);
    setTotal(res.data.body?.total ?? 0);
    setLoading(false);
  } catch (e) {
    console.error(
      `getStandingOrderBankTransferCancelReasonsListOperation failed with error: ${e}`,
    );
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setLoading(false);
  }
};
